import { Component, Input, EventEmitter, Output, NgModule } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MultiSelectDropDownModule } from 'ecova-multi-select-drop-down';

var FilterSelectorComponent = /** @class */ (function () {
    function FilterSelectorComponent(_formBuilder) {
        this._formBuilder = _formBuilder;
        this.filters = [];
        this.numColumns = 3;
        this.filtersChanged = new EventEmitter();
        this._filters = [];
        this._nameOptions = [];
        this.defaultType = {
            fieldName: 'type',
            type: 'select',
            label: 'Type',
            defaultValue: null,
            options: null,
            placeholder: ''
        };
        this.defaultOwner = {
            fieldName: 'owner',
            type: 'select',
            label: 'Owner',
            defaultValue: null,
            options: null,
            placeholder: ''
        };
    }
    FilterSelectorComponent.prototype.ngOnInit = function () {
        var _this = this;
        for (var i = 0; i < this.filters.length / this.numColumns; i++) {
            var temp = [];
            for (var j = 0; j < this.numColumns; j++) {
                if (this.filters[(i * this.numColumns) + j]) {
                    temp.push(this.filters[(i * this.numColumns) + j]);
                }
            }
            this._filters.push(temp);
        }
        this._filterForm = this._formBuilder.group({});
        this.filters.forEach(function (val) {
            if (val.fieldName === 'type') {
                _this.defaultType.defaultValue = val.defaultValue;
                _this.defaultType.options = val.options;
            }
            if (val.fieldName === 'owner') {
                _this.defaultOwner.defaultValue = val.defaultValue;
                _this.defaultOwner.options = val.options;
            }
            _this._filterForm.addControl(val.fieldName, _this._formBuilder.control(val.defaultValue));
        });
        this._filterForm.valueChanges.subscribe(this.onFiltersChanged);
    };
    FilterSelectorComponent.prototype.onFiltersChanged = function (event) {
    };
    FilterSelectorComponent.prototype.onMultiselectSearch = function (event, idx) {
    };
    FilterSelectorComponent.prototype.onApply = function () {
        this.filtersChanged.emit(this._filterForm.value);
    };
    FilterSelectorComponent.prototype.onClear = function () {
        this._filterForm.reset();
        if (this.defaultType.options) {
            this._filterForm.setControl('type', this._formBuilder.control(this.defaultType.options[0].id));
        }
        if (this.defaultOwner.options) {
            this._filterForm.setControl('owner', this._formBuilder.control(this.defaultOwner.options[0].id));
        }
        this.filtersChanged.emit(this._filterForm.value);
    };
    return FilterSelectorComponent;
}());
FilterSelectorComponent.decorators = [
    { type: Component, args: [{
                selector: 'ecova-filter-selector',
                template: "<form class=\"filter-container\" [formGroup]=\"_filterForm\" *ngIf=\"filters && _filterForm\" (keyup.enter)=\"onApply()\">\n  <div class=\"form-group\">\n    <div class=\"row\" *ngFor=\"let filters of _filters; let idx = index;\">\n      <div class=\"col-3\" *ngFor=\"let filter of filters; let idx2 = index\">\n        <div *ngIf=\"filter.type === 'dropdown'\" class=\"select-input\">\n          <label for=\"{{filter.fieldName}}\">{{filter.label}}:&nbsp;</label>\n          <ecova-multi-select-drop-down formControlName=\"{{filter.fieldName}}\"\n                                        [options]=\"filter.options\"\n                                        (onSearch)=\"onMultiselectSearch($event)\"\n                                        tabindex=\"{{(idx * 3) + idx2 + 1}}\">\n          </ecova-multi-select-drop-down>\n        </div>\n        <div *ngIf=\"filter.type === 'select'\" class=\"select-input\">\n          <label for=\"{{filter.fieldName}}\">{{filter.label}}:&nbsp;</label>\n          <select class=\"form-control\"\n                  formControlName=\"{{filter.fieldName}}\"\n                  id=\"{{filter.fieldName}}\"\n                  name=\"{{filter.fieldName}}\"\n                  [value]=\"filter.defaultValue\"\n                  tabindex=\"{{(idx * 3) + idx2 + 1}}\">\n            <option *ngFor=\"let option of filter.options\" value=\"{{option.id}}\"\n                    [selected]=\"filter.defaultValue==option.id?'selected':''\">\n              {{option.name}}\n            </option>\n          </select>\n        </div>\n        <div *ngIf=\"filter.type === 'text'\" class=\"text-input\">\n          <label for=\"{{filter.fieldName}}\">{{filter.label}}:&nbsp;</label>\n          <input class=\"form-control\"\n                 type=\"text\"\n                 formControlName=\"{{filter.fieldName}}\"\n                 id=\"{{filter.fieldName}}\"\n                 name=\"{{filter.fieldName}}\"\n                 [value]=\"filter.defaultValue\"\n                 tabindex=\"{{(idx * 3) + idx2 + 1}}\"\n                 placeholder=\"{{filter.placeholder}}\" />\n        </div>\n        <div *ngIf=\"filter.type === 'date'\" class=\"text-input\">\n          <label for=\"{{filter.fieldName}}\">{{filter.label}}:&nbsp;</label>\n          <input class=\"form-control\"\n                 type=\"date\"\n                 formControlName=\"{{filter.fieldName}}\"\n                 id=\"{{filter.fieldName}}\"\n                 name=\"{{filter.fieldName}}\"\n                 [value]=\"filter.defaultValue\"\n                 tabindex=\"{{(idx * 3) + idx2 + 1}}\"\n                 placeholder=\"{{filter.placeholder}}\" />\n        </div>\n        <div *ngIf=\"filter.type ==='check'\" class=\"check-input\">\n          <label for=\"{{filter.fieldName}}\">{{filter.label}}:&nbsp;</label>\n          <input class=\"check-form-control\"\n                 type=\"checkbox\"\n                 formControlName=\"{{filter.fieldName}}\"\n                 id=\"{{filter.fieldName}}\"\n                 name=\"{{filter.fieldName}}\"\n                 checked=\"filter.defaultValue\"\n                 tabindex=\"{{(idx*3)+ idx2 +1}}\">\n        </div>\n      </div>\n      <div class=\"col-3\" *ngIf=\"(idx === _filters.length - 1) && (filters.length < 3)\"></div>\n      <div class=\"col-3\" *ngIf=\"(idx === _filters.length - 1) && (filters.length < 2)\"></div>\n      <div class=\"col-3\" *ngIf=\"(idx === _filters.length - 1) && (filters.length < 1)\"></div>\n      <div class=\"col-3 buttons\" *ngIf=\"idx === _filters.length - 1\">\n        <button type=\"button\" class=\"btn btn-secondary\" (click)=\"onClear()\">Clear</button>\n        <button type=\"button\" class=\"btn btn-primary\" (click)=\"onApply()\" [disabled]=\"!_filterForm.dirty\">Apply</button>\n      </div>\n    </div>\n  </div>\n</form>\n",
                styles: [".select-input,.text-input{font-size:0}label{display:inline-block;width:40%;font-size:.8rem;text-align:right;vertical-align:middle;margin-bottom:0;padding-right:5px}input{display:inline-block;width:60%;font-size:1rem;vertical-align:middle}.check-form-control{width:auto;height:20px}select{display:inline-block;width:60%;font-size:1rem;vertical-align:middle;height:calc(2.025rem + 6px)!important}.buttons{text-align:right}.row{height:50px}.form-group{margin-bottom:0;padding-bottom:0}ecova-multi-select-drop-down{position:relative;width:60%;display:inline-block;vertical-align:middle}ecova-multi-select-drop-down ::ng-deep .dropdown{padding:0;border:none}ecova-multi-select-drop-down ::ng-deep .toggle{padding:5px 10px;border:1px solid #ccc;border-radius:3px;height:38px;line-height:25px}ecova-multi-select-drop-down ::ng-deep .toggle i{top:11px}ecova-multi-select-drop-down ::ng-deep .search-container{display:none}ecova-multi-select-drop-down ::ng-deep .menu{z-index:999;background:#fff;border-bottom:1px solid #ccc;border-left:1px solid #ccc;border-right:1px solid #ccc;padding:0 10px 5px;position:absolute;width:100%;border-bottom-left-radius:3px;border-bottom-right-radius:3px}"]
            },] },
];
FilterSelectorComponent.ctorParameters = function () { return [
    { type: FormBuilder, },
]; };
FilterSelectorComponent.propDecorators = {
    "filters": [{ type: Input },],
    "numColumns": [{ type: Input },],
    "filtersChanged": [{ type: Output },],
};
var Filter = /** @class */ (function () {
    function Filter() {
    }
    return Filter;
}());
var FilterSelectorModule = /** @class */ (function () {
    function FilterSelectorModule() {
    }
    return FilterSelectorModule;
}());
FilterSelectorModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    MultiSelectDropDownModule
                ],
                declarations: [FilterSelectorComponent],
                exports: [
                    FilterSelectorComponent,
                    FormsModule,
                    ReactiveFormsModule,
                    MultiSelectDropDownModule
                ]
            },] },
];

export { FilterSelectorModule, FilterSelectorComponent, Filter };
//# sourceMappingURL=ecova-filter-selector.js.map
